import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import FeaturedMovies from "./components/FeaturedMovies";
import LatestMovies from "./components/LatestMovies";
import CtaSection from "./components/CtaSection";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedMovies />
        <LatestMovies />
        <CtaSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "天堂影视",
            url: "https://tiantangmovies.com",
            description:
              "天堂影视电影大全，免费在线观看高清蓝光画质，不缓冲不卡顿，收录最新电影、高分电影，影视在线播放，免广告畅享观影体验，每日更新电影资源。",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://tiantangmovies.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "天堂影视",
            url: "https://tiantangmovies.com",
            description:
              "天堂影视 - 电影大全免费在线观看高清蓝光不缓冲不卡顿，最新电影高分电影天堂影视影视在线免广告不卡顿",
            sameAs: [],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "天堂影视 - 首页",
            url: "https://tiantangmovies.com",
            description:
              "天堂影视电影大全，免费在线观看高清蓝光画质，不缓冲不卡顿，收录最新电影、高分电影，影视在线播放，免广告畅享观影体验，每日更新电影资源。",
            isPartOf: {
              "@type": "WebSite",
              name: "天堂影视",
              url: "https://tiantangmovies.com",
            },
          }),
        }}
      />
    </>
  );
}